import React from 'react';
import { useTranslation } from '../../../context/LanguageContext';
import './ModalHeader.css';

const ModalHeader = ({ title, onClose, loading }) => {
  const { t } = useTranslation();

  const handleClose = (e) => {
    e.stopPropagation();
    if (!loading) {
      onClose();
    }
  };

  return (
    <div className="modal-header">
      <h2>{title || t('cashier.payment.title')}</h2>
      <button 
        className="close-button" 
        onClick={handleClose}
        disabled={loading}
      >
        &times;
      </button>
    </div>
  );
};

export default ModalHeader;
